import { httpCreate } from './http';

const http = httpCreate('/srv/activity-gift');

export const activityGift = {
	list(activityId, params) {
		return http.get(`list/pc/${activityId}`);
	},
	status(id, status) {
		return http.post(`status/${id}/${status}`);
	},
	save(params) {
		return http.post('', params);
	},
	edit(id, params) {
		return http.post(`${id}`, params);
	},
	deleteContent(id) {
		return http.delete(`${id}`);
	},
	reset(activityId) {
		return http.post(`reset/${activityId}`);
	},
	applyAll(activityId) {
		return http.post(`applyAll/${activityId}`);
	},
	sort(activityId, params) {
		return http.put(`changeOrder/${activityId}`, params);
	},
};
